import { Link } from 'react-router-dom'
import './Products.css'

const Products = () => {
  return (
    <div className="products-page">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>NEXPA 플랫폼</h1>
            <p className="hero-subtitle">
              AI 기반 문해력 평가 및 학습 솔루션
            </p>
          </div>
        </div>
      </section>

      {/* Main Platform */}
      <section className="main-platform">
        <div className="container">
          <div className="platform-content">
            <div className="platform-info">
              <h2>📘 LIDIA Literacy System</h2>
              <p className="platform-description">
                AI 기반 문항 생성 및 맞춤형 독서 평가 시스템으로, 
                개인별 문해력 수준을 정확히 진단하고 체계적인 학습 경로를 제공합니다.
              </p>
              
              <div className="features-list">
                <h3>주요 기능</h3>
                <ul>
                  <li>✓ AI 기반 문항 생성 및 맞춤형 독서 평가</li>
                  <li>✓ 단계별 독서 게임과 실시간 피드백</li>
                  <li>✓ 인증서 발급 및 성향 분석 리포트</li>
                  <li>✓ 개인별 맞춤형 학습 경로 제안</li>
                  <li>✓ 진도 추적 및 성과 분석</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Secondary Platforms */}
      <section className="secondary-platforms">
        <div className="container">
          
          <div className="platforms-grid">
            <div className="platform-card card">
              <div className="platform-icon">🌐</div>
              <h3>NEXPA MAP</h3>
              <p>게임 결과 기반 지식 확장 맵을 제공하여 학습자의 관심 분야와 강점을 시각적으로 표현합니다.</p>
              
              <div className="features">
                <h4>특징</h4>
                <ul>
                  <li>게임 결과 기반 지식 확장 맵 제공</li>
                  <li>다양한 주제·분야별 시각적 학습 도구</li>
                  <li>개인화된 학습 여정 시각화</li>
                </ul>
              </div>
            </div>
            
            <div className="platform-card card">
              <div className="platform-icon">🎓</div>
              <h3>NEXPA Edu 플랫폼</h3>
              <div className="coming-soon-badge">개발 예정</div>
              <p>교육기관과 연계된 종합 학습 플랫폼으로, 출판사 제휴를 통한 풍부한 콘텐츠를 제공할 예정입니다.</p>
              
              <div className="features">
                <h4>예정 기능</h4>
                <ul>
                  <li>파트너 교육기관 및 콘텐츠 연계 시스템</li>
                  <li>출판사 제휴 기반 콘텐츠 확장</li>
                  <li>통합 학습 관리 시스템</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Solutions */}
      <section className="product-solutions">
        <div className="container">
          <h2 className="section-title">LIDIA SOLUTION LINEUP</h2>
          
          <div className="solutions-grid">
            <div className="solution-card">
              <div className="solution-icon">📘</div>
              <h3>Nexpa LIDIA All</h3>
              <p>전 연령대를 위한 종합 문해력 평가 시스템</p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">📙</div>
              <h3>Nexpa LIDIA Elementary</h3>
              <p>초등학생 전용 맞춤형 독서 평가 도구</p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">📗</div>
              <h3>Nexpa LIDIA Teen</h3>
              <p>청소년을 위한 고급 문해력 분석 시스템</p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">📕</div>
              <h3>Nexpa LIDIA Classic</h3>
              <p>고전 문학 기반 심화 독서 평가</p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">📔</div>
              <h3>LIDIA Select 100</h3>
              <p>엄선된 100권의 도서 기반 평가 시스템</p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">📒</div>
              <h3>LIDIA Map & Report</h3>
              <p>상세한 분석 리포트 및 학습 지도 제공</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="products-cta">
        <div className="container">
          <div className="cta-content card">
            <h2>플랫폼 체험하기</h2>
            <p>
              NEXPA의 혁신적인 AI 문해력 평가 시스템을 직접 경험해보세요.<br />
              무료 체험 및 데모 요청이 가능합니다.
            </p>
            <div className="cta-buttons">
              <a 
                href="https://lidia.nexpa-ai.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                무료 체험하기
              </a>
              <Link to="/contact" className="btn btn-secondary">데모 요청</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Products 